/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetAIConfigQuickStatsPathParams = NonNullable<operations['getAIConfigQuickStats']['parameters']['path']>;

export type GetAIConfigQuickStatsQueryParams = NonNullable<operations['getAIConfigQuickStats']['parameters']['query']>;

export interface Input extends GetAIConfigQuickStatsPathParams {
  apiVersion?: string;
  query: GetAIConfigQuickStatsQueryParams;
}

export async function getAIConfigQuickStats(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/ai-configs/quick-stats', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
